import { CustomerActionTypes } from '../../../enums/ActionEnums';
const customerActions = {
    getProfile() {
        return {
            type: CustomerActionTypes.GET_PROFILE,
        };
    },
    setProfile(payload) {
        return {
            type: CustomerActionTypes.SET_PROFILE,
            payload,
        };
    },
    getDeliveryAddresses() {
        return {
            type: CustomerActionTypes.GET_DELIVERY_ADDRESSES,
        };
    },
    setDeliveryAddresses(payload) {
        return {
            type: CustomerActionTypes.SET_DELIVERY_ADDRESSES,
            payload,
        };
    },
    deleteDeliveryAddress(payload) {
        return {
            type: CustomerActionTypes.DELETE_DELIVERY_ADDRESS,
            payload,
        };
    },
    addDeliveryAddress(payload) {
        return {
            type: CustomerActionTypes.ADD_DELIVERY_ADDRESS,
            payload,
        };
    },
};
export default customerActions;
